import { Component } from '@angular/core';
import {UserResponse} from '../../@shared/models/response.module';
import {UserService} from '../../@core/services/user.service';

@Component({
  selector: 'app-user-profile',
  standalone: false,
  templateUrl: './user-profile.html',
  styleUrl: './user-profile.css'
})
export class UserProfile {
  user: UserResponse
  selectedTab: string = 'overview'

  constructor(private userService: UserService) {
  }

  ngOnInit() {
    this.getUser();
  }

  getUser() {
    this.userService.getUser().subscribe((res) => {
      this.user = res.data;
    });
  }
}
